import { Bot, User, Clock, CheckCircle } from "lucide-react";

const Message = ({ message, isUser, timestamp, darkMode }) => (
  <div className={`flex gap-3 ${isUser ? "flex-row-reverse" : ""} mb-6`}>
    {/* Avatar */}
    <div
      className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
        isUser
          ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white"
          : darkMode
          ? "bg-gray-700 text-white"
          : "bg-gray-100 text-gray-600"
      }`}
    >
      {isUser ? <User size={20} /> : <Bot size={20} />}
    </div>

    {/* Bubble + Metadata */}
    <div
      className={`max-w-[70%] ${
        isUser ? "items-end" : "items-start"
      } flex flex-col gap-2`}
    >
      <div
        className={`p-4 rounded-2xl ${
          isUser
            ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-tr-md"
            : darkMode
            ? "bg-gray-800 text-gray-100 border border-gray-700 rounded-tl-md"
            : "bg-white text-gray-700 shadow-md border border-gray-100 rounded-tl-md"
        }`}
      >
        <p
          className="text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>

      <div
        className={`flex items-center gap-2 text-xs ${
          darkMode ? "text-gray-400" : "text-gray-500"
        }`}
      >
        <Clock size={12} />
        <span>{timestamp}</span>
        {isUser && <CheckCircle size={12} className="text-green-500" />}
      </div>
    </div>
  </div>
);

export default Message